<template>
    <div>
        <voyage :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='3'"/>
        <auto :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='1'"/>
        <habitation :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='2'"/>
    </div>
</template>

<script>
import voyage from './replay/voyage.vue'
import auto from './replay/automobile.vue'
import habitation from './replay/habitation.vue'
export default {
    props: ['all'],
    components:{ voyage, auto, habitation },
    data: () => ({
        subscription: {}
    }),
    created(){
        this.subscription = JSON.parse(this.all);
    }
}
</script>
